const SHIFT_ACTION = {
  //get list shift type
  GET_SHIFT_TYPES: "GET_SHIFT_TYPES",
  GET_SHIFT_TYPES_SUCCESS: "GET_SHIFT_TYPES_SUCCESS",
  GET_SHIFT_TYPES_FAIL: "GET_SHIFT_TYPES_FAIL",
  //add shift type
  ADD_NEW_SHIFT: "ADD_NEW_SHIFT",
  ADD_NEW_SHIFT_SUCCESS: "ADD_NEW_SHIFT_SUCCESS",
  ADD_NEW_SHIFT_FAIL: "ADD_NEW_SHIFT_FAIL",
  //delete shift type
  DELETE_SHIFT_TYPE: "DELETE_SHIFT_TYPE",
  DELETE_SHIFT_TYPE_SUCCESS: "DELETE_SHIFT_TYPE_SUCCESS",
  DELETE_SHIFT_TYPE_FAIL: "DELETE_SHIFT_TYPE_FAIL",
  //edit shift type
  EDIT_SHIFT_TYPE: "EDIT_SHIFT_TYPE",
  EDIT_SHIFT_TYPE_SUCCESS: "EDIT_SHIFT_TYPE_SUCCESS",
  EDIT_SHIFT_TYPE_FAIL: "EDIT_SHIFT_TYPE_FAIL",
  //get 1 shift type
  GET_SHIFT_TYPE_BY_ID: "GET_SHIFT_TYPE_BY_ID",
  GET_SHIFT_TYPE_BY_ID_SUCCESS: "GET_SHIFT_TYPE_BY_ID_SUCCESS",
  GET_SHIFT_TYPE_BY_ID_FAIL: "GET_SHIFT_TYPE_BY_ID_FAIL",
  //get all shifts
  GET_ALL_SHIFTS: "GET_ALL_SHIFTS",
  GET_ALL_SHIFTS_SUCCESS: "GET_ALL_SHIFTS_SUCCESS",
  GET_ALL_SHIFTS_FAIL: "GET_ALL_SHIFTS_FAIL",
  // get all shifts overtime
  GET_ALL_SHIFTS_OVERTIME: "GET_ALL_SHIFTS_OVERTIME",
  GET_ALL_SHIFTS_OVERTIME_SUCCESS: "GET_ALL_SHIFTS_OVERTIME_SUCCESS",
  GET_ALL_SHIFTS_OVERTIME_FAIL: "GET_ALL_SHIFTS_OVERTIME_FAIL",
  // get shift
  GET_SHIFT: "GET_ALL_SHIFT",
  GET_SHIFT_SUCCESS: "GET_SHIFT_SUCCESS",
  GET_SHIFT_FAIL: "GET_SHIFT_FAIL",
  // request Export CSV
  EXPORT_CSV_REQUEST: "EXPORT_CSV_REQUEST",
  EXPORT_CSV_SUCCESS: "EXPORT_CSV_SUCCESS",
  EXPORT_CSV_FAIL: "EXPORT_CSV_FAIL",
  //request get generate
  GET_GENERATE_REQUEST: "GET_GENERATE_REQUEST",
  GET_GENERATE_SUCCESS: "GET_GENERATE_SUCCESS",
  GET_GENERATE_FAIL: "GET_GENERATE_FAIL",
  //get list shift sessions
  GET_SHIFT_SESIONS: "GET_SHIFT_SESIONS",
  GET_SHIFT_SESIONS_SUCCESS: "GET_SHIFT_SESIONS_SUCCESS",
  GET_SHIFT_SESIONS_FAIL: "GET_SHIFT_SESIONS_FAIL",
  //update shift sessions
  UPDATE_SHIFT_SESSIONS: "UPDATE_SHIFT_SESSIONS",
  UPDATE_SHIFT_SESSIONS_SUCCESS: "UPDATE_SHIFT_SESSIONS_SUCCESS",
  UPDATE_SHIFT_SESSIONS_FAIL: "UPDATE_SHIFT_SESSIONS_FAIL",
  //get all branches
  GET_ALL_BRANCH_REQUEST: "GET_ALL_BRANCH_REQUEST",
  GET_ALL_BRANCH_SUCCESS: "GET_ALL_BRANCH_SUCCESS",
  GET_ALL_BRANCH_FAIL: "GET_ALL_BRANCH_FAIL",
  // get all teams
  GET_ALL_TEAM_REQUEST: "GET_ALL_TEAM_REQUEST",
  GET_ALL_TEAM_SUCCESS: "GET_ALL_TEAM_SUCCESS",
  GET_ALL_TEAM_FAIL: "GET_ALL_TEAM_FAIL",
  // get all users
  GET_ALL_USER_REQUEST: "GET_ALL_USER_REQUEST",
  GET_ALL_USER_SUCCESS: "GET_ALL_USER_SUCCESS",
  GET_ALL_USER_FAIL: "GET_ALL_USER_FAIL",
  // clear filter
  CLEAR_FILTER_WORKED_SHIFT: "CLEAR_FILTER_WORKED_SHIFT",
};
export default SHIFT_ACTION;
